import React, {useEffect, useState} from "react";
import "./styles.css";
import {Button, Checkbox, Collapse, DatePicker, Modal, Row, Space, Table, Tooltip} from "antd";
import moment from "moment";
import HeaderChart from "./Charts/HeaderChart";
import TunnelChart from "./Charts/TunnelChart";
import PieChart from "./Charts/DevicesChart";
import AgeChart from "./Charts/AgeChart";
import axios from "axios";
import environment from "../../../../environment";
import {cookieService} from "../../../../services/cookie.service";
import getAppCountry from "../../../../utils/getAppCountry";
import {InfoCircleOutlined} from "@ant-design/icons";
import {formService} from "../../../../services/form.service";
import LineChart from "./Charts/LineChart";
import BarChart from "./Charts/BarChart";
const {RangePicker} = DatePicker;

export default function DashboardPage() {
  const [selectedDate, setSelectedDate] = useState({
    startDate: moment().startOf("month"),
    endDate: moment(new Date())
  });

  const [topChartsData, setTopChartsData] = useState({
    forms: {},
    amount: {},
    taxAmount: {}
  });
  const [funnelData, setFunnelData] = useState(null);
  const [mobileData, setMobileData] = useState({
    web: 0,
    mobile: 0
  });
  const [agesData, setAgesData] = useState({
    "18-24": 0,
    "25-34": 0,
    "35-44": 0,
    "45-64": 0,
    "65+": 0
  });

  const getChartsData = async (startDate, endDate) => {
    const cookieToken = await new cookieService().getAdminTokenData();
    const queryParams = {};
    Object.assign(queryParams, {startDate: startDate ? startDate : moment(selectedDate.startDate, "DD.MM.YYYY")});
    Object.assign(queryParams, {endDate: endDate ? endDate : moment(selectedDate.endDate, "DD.MM.YYYY")});
    const response = await new formService().getChartInfo(queryParams);
    if (response && response.data) {
      setTopChartsData(response.data);
    }
    if (getAppCountry() !== "DE") {
      // Funnel data
      const funnelResponse = await new formService().getChartFunnel(queryParams);
      if (funnelResponse && funnelResponse.data) {
        setFunnelData(funnelResponse.data);
      }
      // Devices data
      const devicesResponse = await new formService().getChartDevices(queryParams);
      if (devicesResponse && devicesResponse.data) {
        setMobileData(devicesResponse.data);
      }
      // Ages data
      const agesResponse = await new formService().getChartAges(queryParams);
      if (agesResponse && agesResponse.data) {
        setAgesData(agesResponse.data);
      }
    }
  };

  const [selectedSupportFROM, setSelectedSupportFROM] = useState(null);
  const [selectedSupportTO, setSelectedSupportTO] = useState(null);
  const [selectedSBreport, setSelectedSBreport] = useState(null);
  const [totalAssignedUnsent, setTotalAssignedUnsent] = useState(0);
  const [assignedUnsentGroups, setAssignedUnsentGroups] = useState([]);
  const [failedSendingForms, setFailedSendingForms] = useState(null);
  const [deleteFailedForm, setDeleteFailedForm] = useState(null);
  const [failedFormConfirmation, setFailedFormConfirmation] = useState(false);
  const [lineChartData, setLineChartData] = useState([]);
  const [failureCodeChartData, setFailureCodeChartData] = useState([]);
  const [fsfChartDisplay, setFsfChartDisplay] = useState([]);

  const getTotalAssignedUnsent = async () => {
    const result = await new formService().getTotalAssignedUnsent();
    setTotalAssignedUnsent(result.data.data[0].total);
  };

  const getGroupAssignedUnsent = async () => {
    const result = await new formService().getGroupAssignedUnsent();
    const groupTemplate = result.data.data.map((el, idx) => (
      <td key={"assigned-unsent-group-" + idx}>
        <h2>G-{el.group}</h2>
        <h3>{el.total}</h3>
      </td>
    ));
    setAssignedUnsentGroups(groupTemplate);
  };

  const getFailedSendingForms = async () => {
    const result = await new formService().getFailedSendingForms();
    console.log("fsf", result);
    setFailedSendingForms(result.data);
  };

  const downloadForm = async record => {
    await new formService().downloadZIP(record.form_id);
  };

  const deleteFailedFormConfirmation = record => {
    setDeleteFailedForm(record.form_id);
    setFailedFormConfirmation(true);
  };

  const generateLineChartData = () => {
    console.log(failedSendingForms);
    if (!failedSendingForms || failedSendingForms?.sentForms?.length == 0) return;
    const result = [
      {
        id: "Failed-Sending",
        data: []
      },
      {
        id: "Sent-Forms",
        data: []
      }
    ];

    const dates = Array.from(new Set(failedSendingForms.failedForms.map(el => el.created_at.split("T")[0])));
    result[0].data = dates
      .map(el => ({
        x: el,
        y: failedSendingForms.failedForms.filter(ell => ell.created_at.split("T")[0] == el).length
      }))
      .reverse();
    result[1].data = failedSendingForms.sentForms
      .map(el => ({
        x: el.send_date.split("T")[0],
        y: +el.count
      }))
      .filter(el => result[0].data.map(ell => ell.x).includes(el.x))
      .reverse();
    console.log(result);
    setLineChartData(result);
  };

  const handleSBReportDate = data => {
    setSelectedSBreport(data?.toISOString());
  };

  const handleSupportFROM = data => {
    setSelectedSupportFROM(data?.toISOString());
  };

  const handleSupportTO = data => {
    setSelectedSupportTO(data?.toISOString());
  };

  const downloadSupportConversations = async () => {
    const result = await new formService().downloadSupportConversations({
      startDate: moment(selectedSupportFROM).format("DD.MM.YYYY"),
      endDate: moment(selectedSupportTO).format("DD.MM.YYYY")
    });
  };

  const downloadSBreport = async () => {
    const result = await new formService().downloadTaxConsultantReport(selectedSBreport);
  };

  useEffect(() => {
    getChartsData();
    getTotalAssignedUnsent();
    getGroupAssignedUnsent();
    getFailedSendingForms();
  }, []);

  const generateFailureCodeChartData = () => {
    if (!failedSendingForms) return;
    const temp = failedSendingForms.failedForms.map(el => ({...el, created_at: el.created_at.split("T")[0]})).reverse();

    const distinctComments = [...new Set(temp.map(el => el.comment))].reverse();
    const result = [];
    for (const form of temp) {
      const endObj = result.find(el => el.created_at == form.created_at);
      if (!endObj) {
        const obj = {
          created_at: form.created_at
        };
        for (const comment of distinctComments) {
          obj[comment] = 0;
        }
        obj[form.comment] += 1;
        result.push(obj);
      } else {
        if (endObj[form.comment]) {
          endObj[form.comment] += 1;
        } else {
          endObj[form.comment] = 1;
        }
      }
    }
    console.log(result);
    setFailureCodeChartData(result);
  };

  useEffect(() => {
    generateLineChartData();
    generateFailureCodeChartData();
  }, [failedSendingForms]);

  return (
    <div>
      <div className="space-between">
        <h1>Dashboard</h1>
        <RangePicker
          defaultValue={[selectedDate.startDate, selectedDate.endDate]}
          format={"DD.MM.YYYY"}
          onChange={val => {
            setSelectedDate({
              startDate: moment(val[0]).format("DD.MM.YYYY"),
              endDate: moment(val[1]).format("DD.MM.YYYY")
            });
            setTimeout(() => {
              getChartsData(moment(val[0]), moment(val[1]));
            }, 100);
          }}
        />
      </div>

      <div className="dashboard_header_charts">
        <HeaderChart id={"Forms"} title={"Steurerklärungen"} withBorder data={topChartsData.forms} />
        <HeaderChart id={"Amount"} title={"Steueranspruch kumuliert"} withBorder data={topChartsData.amount} />
        <HeaderChart id={"tax_amount"} title={"Transaktionsvolumen Finanzamt"} data={topChartsData.taxAmount} />
      </div>

      {getAppCountry() !== "DE" && (
        <div className="dashboard_header_charts">
          <div>
            <h2>Assigned but not sent - Total</h2>
            <h3>{totalAssignedUnsent}</h3>
          </div>
          <table>
            <tr>{assignedUnsentGroups}</tr>
          </table>
        </div>
      )}

      {getAppCountry() !== "DE" && (
        <div className="dashboard_header_charts">
          <div>
            <h2>Support-Conversations</h2>
            <DatePicker onChange={handleSupportFROM} />
            <DatePicker onChange={handleSupportTO} />
            <Button disabled={!selectedSupportFROM || !selectedSupportTO} onClick={() => downloadSupportConversations()}>
              Download
            </Button>
          </div>
          <div>
            <h2>
              Steuerberater-Report{" "}
              <Tooltip title={"Das genaue Datum ist unwichtig, es wird das Jahr und der Monat berücksichtigt"}>
                <InfoCircleOutlined />
              </Tooltip>
            </h2>
            <DatePicker onChange={handleSBReportDate} />
            <Button onClick={() => downloadSBreport()}>Download</Button>
          </div>
        </div>
      )}

      {getAppCountry() !== "DE" && (
        <>
          <Modal
            open={failedFormConfirmation}
            onCancel={() => {
              setDeleteFailedForm(null);
              setFailedFormConfirmation(false);
            }}
            onOk={async () => {
              await new formService().deleteFailedForm(deleteFailedForm);
              setFailedFormConfirmation(false);
              getFailedSendingForms();
            }}
          >
            Are you sure you want to remove {deleteFailedForm} from table failed-sending-forms?
          </Modal>
          <div
            style={{
              width: "100%",
              marginTop: "40px",
              paddingBottom: "20px",
              borderBottom: "2px solid #eeeeee",
              marginBottom: "10px"
            }}
          >
            <h1>Failed Sending Forms - {failedSendingForms?.failedForms?.length || 0}</h1>
            <Collapse>
              <Collapse.Panel header={<h1>Table</h1>} showArrow={false}>
                <Table
                  pagination={{
                    showTotal: total => failedSendingForms?.failedForms.length || 0,
                    defaultPageSize: 50
                  }}
                  dataSource={failedSendingForms?.failedForms}
                  scroll={{y: 400}}
                  columns={[
                    {
                      title: "Form-ID",
                      dataIndex: "form_id",
                      key: "form_id",
                      sorter: (a, b) => a.form_id - b.form_id,
                      sortDirections: ["ascend", "descend", "ascend"]
                    },
                    {
                      title: "Created at",
                      dataIndex: "created_at",
                      key: "created_at",
                      sorter: (a, b) => (a.created_at > b.created_at ? 1 : -1),
                      sortDirections: ["ascend", "descend", "ascend"]
                    },
                    {
                      title: "Payment-Plan",
                      dataIndex: "plan",
                      key: "plan",
                      sorter: (a, b) => (a.plan > b.plan ? 1 : -1),
                      sortDirections: ["ascend", "descend", "ascend"]
                    },
                    {
                      title: "Comment",
                      dataIndex: "comment",
                      key: "comment",
                      sorter: (a, b) => (a.plan > b.plan ? 1 : -1),
                      sortDirections: ["ascend", "descend", "ascend"]
                    },
                    {
                      title: "Actions",
                      key: "actions",
                      render: (_, record) => (
                        <Space size="middle">
                          <Button onClick={() => downloadForm(record)}>Download</Button>
                          <Tooltip
                            title={"Removing from failed-sending-forms table will cause the system to try to re-send the form after a set delay"}
                          >
                            <Button onClick={() => deleteFailedFormConfirmation(record)} danger>
                              Remove
                            </Button>
                          </Tooltip>
                        </Space>
                      )
                    }
                  ]}
                />
              </Collapse.Panel>
              <Collapse.Panel header={<h1>Statistic</h1>} showArrow={false}>
                <Checkbox.Group
                  onChange={checkedValue => {
                    console.log("checkedValue", checkedValue);
                    setFsfChartDisplay(checkedValue);
                    setTimeout(() => {
                      window.scrollTo(0, document.body.scrollHeight);
                    }, 500);
                  }}
                >
                  <Checkbox value={"plan"}>Plan</Checkbox>
                  <Checkbox value={"failure_code"}>Failure Codes</Checkbox>
                  <Checkbox value={"created_at"}>Created at</Checkbox>
                </Checkbox.Group>
                <div style={{display: "flex", flexWrap: "wrap", overflow: "scroll", justifyContent: "center"}}>
                  <PieChart
                    display={fsfChartDisplay.includes("plan")}
                    labels={{
                      a1: "Basic",
                      b1: "Express"
                    }}
                    data={{
                      a1: failedSendingForms?.failedForms.filter(el => el.plan == "BASIC").length,
                      b1: failedSendingForms?.failedForms.filter(el => el.plan != "BASIC").length
                    }}
                  />

                  <BarChart display={fsfChartDisplay.includes("failure_code")} data={failureCodeChartData} />

                  <LineChart
                    display={fsfChartDisplay.includes("created_at")}
                    style={{overflow: "scroll"}}
                    data={lineChartData}
                    labels={{x: "Date", y: "Failed-Count"}}
                  />
                </div>
              </Collapse.Panel>
            </Collapse>
          </div>
        </>
      )}

      {/* {getAppCountry() !== "DE" &&
        <>
          <h2>Pipeline</h2>

          <TunnelChart data={funnelData} />

          <div
            style={{
              width: "100%",
              backgroundColor: "#ffffff",
              paddingTop: "10px",
              marginTop: "-50px",
              position: "relative",
              zIndex: 2
            }}
          >
            <div style={{width: "100%", height: "2px", backgroundColor: "#eeeeee"}} />

            <div className="bottom_charts_container">
              <DevicesChart data={mobileData} />
              <AgeChart data={agesData} />
            </div>
          </div>
        </>
      )}
      } */}
    </div>
  );
}
